(function () {
  if (customElements.get('mv-social-proof')) return;

  class MvSocialProof extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-mvsp-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-mvsp-prev]');
      this.next = this.querySelector('[data-mvsp-next]');
      this.progress = this.querySelector('[data-mvsp-progress]');
      this.more = this.querySelector('[data-mvsp-more]');
      this.dialog = this.querySelector('[data-mvsp-dialog]');

      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.update);

      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      if (this.more) {
        this.more.addEventListener('click', () => {
          this.querySelectorAll('.mvsp__item--extra').forEach((el) => el.classList.remove('mvsp__item--extra'));
          this.more.remove();
          this.update();
        });
      }

      this.querySelectorAll('[data-mvsp-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.open(btn));
      });

      if (this.dialog) {
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.close();
        });
        const closeBtn = this.dialog.querySelector('[data-mvsp-close]');
        if (closeBtn) closeBtn.addEventListener('click', () => this.close());
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('mvsp-lock');
          if (this.lastTrigger) this.lastTrigger.focus({ preventScroll: true });
        });
      }

      requestAnimationFrame(this.update);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
    }

    step() {
      const item = this.track.querySelector('[data-mvsp-item]:not(.mvsp__item--extra)');
      if (!item) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    go(dir) {
      const perView = Math.max(1, Math.floor((this.track.clientWidth + 1) / this.step()));
      this.track.scrollBy({ left: dir * this.step() * perView, behavior: 'smooth' });
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = max > 4;
      this.classList.toggle('mvsp--static', !scrollable);
      if (!scrollable) return;
      const ratio = Math.min(1, Math.max(0, this.track.scrollLeft / max));
      const visible = this.track.clientWidth / this.track.scrollWidth;
      if (this.progress) {
        this.progress.style.width = (visible * 100).toFixed(2) + '%';
        this.progress.style.transform = 'translateX(' + ((ratio * (1 - visible)) / visible * 100).toFixed(2) + '%)';
      }
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
    }

    open(btn) {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      const card = btn.closest('.mvsp__card');
      const img = btn.querySelector('img');
      const media = this.dialog.querySelector('[data-mvsp-dialog-media]');
      const body = this.dialog.querySelector('[data-mvsp-dialog-body]');
      media.innerHTML = '';
      body.innerHTML = '';
      if (img) {
        const big = document.createElement('img');
        let src = img.currentSrc || img.src;
        if (img.srcset) {
          const last = img.srcset.split(',').map((s) => s.trim().split(' ')[0]).pop();
          if (last) src = last;
        }
        big.src = src;
        big.alt = img.alt || '';
        media.appendChild(big);
      }
      const content = card && card.querySelector('[data-mvsp-body]');
      if (content) body.appendChild(content.cloneNode(true));
      this.lastTrigger = btn;
      document.documentElement.classList.add('mvsp-lock');
      this.dialog.showModal();
    }

    close() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }
  }

  customElements.define('mv-social-proof', MvSocialProof);
})();
